import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {showTag as showTagNavigation} from '../modules/Navigation';
import Tag from './components/Tag';

const TagList = ({tags, showTag, widget, context, selectedTag}) => {
  if (!tags || widget) return null;
  const tagArray = tags.split(',');
  const onClickTag = (tag) => (e) => {
    e.preventDefault();
    showTag(widget, tag, context);
  };
  const tagElements = tagArray.map((tag) =>
    <Tag
      key={tag}
      name={tag}
      isSelected={tag === selectedTag}
      hasSpacing
      className="t-tag"
      onClick={onClickTag(tag)}
    />);
  return (
    <div className="tag-list tag-list--has-spacing">{tagElements}</div>
  );
};

TagList.propTypes = {
  showTag: PropTypes.func.isRequired,
  tags: PropTypes.string,
  selectedTag: PropTypes.string,
  widget: PropTypes.bool,
  context: PropTypes.string,
};

export default connect((state) => ({
  widget: state.environment.widget,
  context: state.environment.widgetConfig.context,
}), {showTag: showTagNavigation})(TagList);
